// /*global kakao*/
import React, { useEffect } from 'react'

const JcoupMap = () => {
  useEffect(() => {
    if (window.kakao && window.kakao.maps) {

      window.kakao.maps.load(() => {
        const container = document.getElementById('map1')
        if (container) {
          const centerPos = new window.kakao.maps.LatLng(35.9019567, 128.5810435);
          const options = {
            center: centerPos,
            level: 3
          };
          const map = new window.kakao.maps.Map(container, options);

          const marker = new window.kakao.maps.Marker({
            position: centerPos
          });
          marker.setMap(map);
        }
      });
    }
  }, []);

  return (
    <>
      <h3 style={{ textAlign: 'center', color: 'blue', backgroundColor: 'lightgray' }}>2공장:(주)제이콥 [접착(수지,캠록,FKM,몰리 등..)]</h3>
      <div>
        <div id="map1" style={{ width: "100%", height: "70vh" }}></div>
      </div>a
      &nbsp;
      <h5 style={{ textAlign: 'center' }}>주소 : 대구시 북구 노원로동 39길6 (침산동)</h5>
    </>
  )
}


export default JcoupMap;